import { Inject, Injectable, InjectionToken } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

export const DEFAULT_TIMEOUT = new InjectionToken<number>('defaultTimeout');
const defaultTimeout = 300000;

@Injectable()
export class TimeoutInterceptor implements HttpInterceptor {
  constructor(
		private toastrService: ToastrService
	) {}
  
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const timeoutValue = req.headers.get('timeout') || defaultTimeout;
    const timeoutValueNumeric = Number(timeoutValue);

    return next.handle(req).pipe(timeout(timeoutValueNumeric), catchError((error) => {
      if(typeof(error.message) != 'undefined' && error.name == 'TimeoutError') {
        console.log(error);
        this.toastrService.warning('Actualmente el servidor se encuentra fuera de servicio. Intente más tarde!', 'TIMEOUT', { timeOut: 10000 });	
      }

      return throwError(error);
    }));
  }
}
